var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSiteLinksIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Link",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Link",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8a3 3 0 013-3h2V3H5a5 5 0 100 10h2v-2H5a3 3 0 01-3-3zm9-5H9v2h2a3 3 0 010 6H9v2h2a5 5 0 100-10zM5.293 8.707A1 1 0 016 7h4a1 1 0 110 2H6a1 1 0 01-.707-.293z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgSiteLinksIcon;